export default "__VITE_ASSET__Y$3lewyH__"